import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Observable } from 'rxjs';
import { FundraisingReportService } from '../../_services/fundraising/fundraisingReport.service';

@Component({
    selector: 'app-saved-report-naming-modal',
    templateUrl: './saved-report-naming-modal.component.html',
    styleUrls: ['./saved-report-naming-modal.component.css']
  })

export class SavedReportNamingModalComponent implements OnInit{

    public name: string;

    public form: FormGroup;

    @Output() submitted = new EventEmitter;

    constructor(
        private bsModalRef: BsModalRef,
        private fb: FormBuilder,
    ){}

    ngOnInit(){
        this.form = this.fb.group({
            name: [this.name, Validators.required]
        })
    }

    saveAndClose() {
        if (this.form.valid){
            this.submitted.emit(this.form.controls.name.value);
            this.close();
        }
    }
      
    close() {
        this.bsModalRef.hide();
    }
}